import { createSelector } from "reselect";

const getData = (state) => state.spaceReservations.data;
const getSpaceReservationEntities = (state) => state.entities.spaceReservations;
const getSpaceEntities = (state) => state.entities.spaces;

/*****************
 *
 * EXPORT METHODS
 *
 *****************/

export const getSpaceReservations = (state) =>
    createSelector(
        getData,
        getSpaceReservationEntities,
        getSpaceEntities,
        (data, spaceReservations, spaces) => {
            return data.map((id) => {
                let reservation = Object.assign({}, spaceReservations[id]);

                reservation.space = spaces[reservation.space];

                return reservation;
            });
        }
    )(state);

export const getSpaceReservation = (state, id) =>
    createSelector(
        getSpaceReservationEntities,
        getSpaceEntities,
        (spaceReservations, spaces) => {
            if (!spaceReservations[id]) return null;

            let reservation = Object.assign({}, spaceReservations[id]);

            reservation.space = spaces[reservation.space];

            return reservation;
        }
    )(state);
